import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, ViewEncapsulation, ContentChildren, HostBinding, NgModule } from '@angular/core';
import { Subject, BehaviorSubject, Subscription } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["accordionHeader"];
const _c1 = ["*"];
function AccordionHeaderComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("font-weight", ctx_r1.rebrand ? null : ctx_r1.fontWeight);
    i0.ɵɵclassProp("active", ctx_r1.isActive);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.headerText, " ");
  }
}
function AccordionHeaderComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "i", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("open", ctx_r1.isActive)("active", ctx_r1.isActive);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.isActive ? "chevron_up" : "chevron_down");
  }
}
function AccordionHeaderComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("open", ctx_r1.isActive)("active", ctx_r1.isActive);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.isActive ? "minus" : "add");
  }
}
const _c2 = ["accordionContent"];
const _c3 = [[["", "header", ""]], "*"];
const _c4 = ["[header]", "*"];
var Keys = /*#__PURE__*/function (Keys) {
  Keys["Tab"] = "Tab";
  Keys["Enter"] = "Enter";
  Keys["Space"] = " ";
  Keys["End"] = "End";
  Keys["Home"] = "Home";
  Keys["Up"] = "ArrowUp";
  Keys["Down"] = "ArrowDown";
  Keys["IEUp"] = "Up";
  Keys["IEDown"] = "Down";
  return Keys;
}(Keys || {});
var Icons = /*#__PURE__*/function (Icons) {
  Icons["Pencil"] = "pencil";
  Icons["NavigationArrowCircle"] = "navigation-arrow-circle";
  Icons["AccountUser"] = "account-user";
  return Icons;
}(Icons || {});
let AccordionService = /*#__PURE__*/(() => {
  class AccordionService {
    constructor() {
      this.focussedItemIndex$ = new Subject();
      this.fontWeight$ = new BehaviorSubject(700);
      this.itemStartIndex = 1;
      this.toggleMultiple = false;
      this.rebrand = false;
    }
    setFocus(itemIndex, key) {
      switch (key) {
        case Keys.Home:
          this.setFocusToFirstElement();
          break;
        case Keys.End:
          this.setFocusToLastElement();
          break;
        case Keys.Up:
        case Keys.IEUp:
          this.setFocusToPrevElement(itemIndex);
          break;
        case Keys.Down:
        case Keys.IEDown:
          this.setFocusToNextElement(itemIndex);
          break;
      }
    }
    setActive(clickedItemIndex) {
      this.accordionItems.forEach(accordionItem => {
        if (accordionItem.itemIndex === clickedItemIndex) {
          accordionItem.isActive = !accordionItem.isActive;
          return;
        }
        if (!this.toggleMultiple) {
          accordionItem.isActive = accordionItem.itemIndex === clickedItemIndex;
        }
      });
    }
    setItemIndex() {
      let index = this.itemStartIndex;
      this.accordionItems.forEach(accordionItem => {
        accordionItem.itemIndex = index++;
      });
    }
    setFocusToPrevElement(itemIndex) {
      const indexToBeFocussed = itemIndex - 1;
      if (indexToBeFocussed === 0) {
        this.setFocusToLastElement();
        return;
      }
      this.focussedItemIndex$.next(indexToBeFocussed);
    }
    setFocusToNextElement(itemIndex) {
      const indexToBeFocussed = itemIndex + 1;
      if (indexToBeFocussed > this.totalItems) {
        this.setFocusToFirstElement();
        return;
      }
      this.focussedItemIndex$.next(indexToBeFocussed);
    }
    setFocusToFirstElement() {
      this.focussedItemIndex$.next(this.itemStartIndex);
    }
    setFocusToLastElement() {
      this.focussedItemIndex$.next(this.totalItems);
    }
  }
  AccordionService.ɵfac = function AccordionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionService)();
  };
  AccordionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccordionService,
    factory: AccordionService.ɵfac
  });
  return AccordionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
  NOTE! Foot-gun ahead!
  Accordion-header-component and accordion-item-component BOTH
  are defined in this file. This is due to Angular refusing to compile
  libraries with circular imports:
  NG3003: One or more import cycles would need to be created to compile this component,
  which is not supported by the current compiler configuration.
*/
let AccordionHeaderComponent = /*#__PURE__*/(() => {
  class AccordionHeaderComponent {
    constructor(accordionService) {
      this.accordionService = accordionService;
      this.icons = 'default';
      this.headingLevel = 3;
      this.rebrand = false;
      this.headerClick = new EventEmitter();
      this.headerKeyUp = new EventEmitter();
      this.fontWeight = 700;
      this.subscription$ = new Subscription();
    }
    ngOnInit() {
      // need to get rebrand-value from accordionService:
      this.rebrand = this.accordionService.rebrand;
      this.subscription$.add(this.accordionService.fontWeight$.subscribe({
        next: fontWeight => {
          this.fontWeight = fontWeight;
        }
      }));
      this.subscription$.add(this.accordionService.focussedItemIndex$.subscribe({
        next: focusedIndex => {
          if (focusedIndex === this.itemIndex && this.accordionHeader) {
            this.accordionHeader.nativeElement.focus();
          }
        }
      }));
    }
    ngOnDestroy() {
      this.subscription$.unsubscribe();
    }
    onHeaderClick(event) {
      this.headerClick.emit(event);
    }
    onHeaderKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault(); // prevent event from firing here, we emit event in keyUp
        return;
      }
      // prevent scrolling
      switch (event.key) {
        case Keys.Space:
        case Keys.Home:
        case Keys.End:
        case Keys.Up:
        case Keys.Down:
        case Keys.IEUp:
        case Keys.IEDown:
          {
            event.preventDefault();
            break;
          }
      }
    }
    onHeaderKeyUp(event) {
      this.headerKeyUp.emit(event);
    }
  }
  AccordionHeaderComponent.ɵfac = function AccordionHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionHeaderComponent)(i0.ɵɵdirectiveInject(AccordionService));
  };
  AccordionHeaderComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AccordionHeaderComponent,
    selectors: [["stb-accordion-header"]],
    viewQuery: function AccordionHeaderComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordionHeader = _t.first);
      }
    },
    inputs: {
      headerText: "headerText",
      icons: "icons",
      isActive: "isActive",
      itemIndex: "itemIndex",
      headingLevel: "headingLevel",
      uniqueId: "uniqueId",
      rebrand: "rebrand"
    },
    outputs: {
      headerClick: "headerClick",
      headerKeyUp: "headerKeyUp"
    },
    ngContentSelectors: _c1,
    decls: 8,
    vars: 8,
    consts: [["accordionHeader", ""], ["plusMinusTemplate", ""], ["role", "button", "tabindex", "0", 1, "stb-accordion-header", "clickable", 3, "click", "keydown", "keyup"], [1, "stb-accordion-header-left"], ["class", "stb-accordion-header-title", 3, "active", "fontWeight", 4, "ngIf"], [4, "ngIf", "ngIfElse"], [1, "stb-accordion-header-title"], ["aria-hidden", "true", "translate", "no", "role", "img", 1, "icon-small"], ["aria-hidden", "true", "translate", "no", "role", "img", 1, "icon-medium"]],
    template: function AccordionHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 2, 0);
        i0.ɵɵlistener("click", function AccordionHeaderComponent_Template_button_click_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onHeaderClick($event));
        })("keydown", function AccordionHeaderComponent_Template_button_keydown_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onHeaderKeyDown($event));
        })("keyup", function AccordionHeaderComponent_Template_button_keyup_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onHeaderKeyUp($event));
        });
        i0.ɵɵelementStart(2, "div", 3);
        i0.ɵɵtemplate(3, AccordionHeaderComponent_span_3_Template, 2, 5, "span", 4);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, AccordionHeaderComponent_ng_container_5_Template, 3, 5, "ng-container", 5)(6, AccordionHeaderComponent_ng_template_6_Template, 2, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        const plusMinusTemplate_r3 = i0.ɵɵreference(7);
        i0.ɵɵclassProp("active", ctx.isActive);
        i0.ɵɵattribute("aria-controls", ctx.uniqueId + "-c-" + ctx.itemIndex)("aria-expanded", ctx.isActive)("id", ctx.uniqueId + "-" + ctx.itemIndex);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.headerText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.rebrand)("ngIfElse", plusMinusTemplate_r3);
      }
    },
    dependencies: [i2.NgIf],
    encapsulation: 2
  });
  return AccordionHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/* ***************************************************
   *************************************************** */
let AccordionItemComponent = /*#__PURE__*/(() => {
  class AccordionItemComponent {
    constructor(accordionService, renderer) {
      this.accordionService = accordionService;
      this.renderer = renderer;
      this.icons = 'default';
      this.isActive = false;
      this.headingLevel = 3;
      this.rebrand = false;
      this.headerClick = new EventEmitter();
      this.headerKeyUp = new EventEmitter();
      this.fontWeight = 700;
      this.subscription$ = new Subscription();
      this.uniqueId = '';
    }
    ngOnInit() {
      this.rebrand = this.accordionService.rebrand;
      // if icons are not specified, set defaults for rebrand or legacy
      // legacy: plusminus, rebrand: chevron
      if (this.icons === 'default') {
        this.icons = this.accordionService.rebrand ? 'chevron' : 'plusminus';
      }
    }
    ngOnChanges(changes) {
      // generate id
      this.uniqueId = 'accordion-' + Math.floor(Math.random() * 999999);
      // set or remove 'role' based on toggleMultiple
      // (toggleMultiple implies removing 'role', to avoid landmark proliferation)
      // need setTimeout here - because magic
      setTimeout(() => {
        if (this.accordionService.toggleMultiple === false) {
          this.renderer.setAttribute(this.contentRef.nativeElement, 'role', 'region');
        } else {
          this.renderer.removeAttribute(this.contentRef.nativeElement, 'role');
        }
      }, 1);
    }
    ngOnDestroy() {
      this.subscription$.unsubscribe();
    }
    onHeaderPanelClick(event) {
      this.accordionService.setActive(this.itemIndex);
      this.headerClick.emit(event);
    }
    onHeaderPanelKeyUp(event) {
      if (event.key === 'Tab') {
        return;
      }
      switch (event.key) {
        case Keys.Enter:
        case Keys.Space:
          {
            event.preventDefault(); // prevent scrolling
            this.accordionService.setActive(this.itemIndex);
            break;
          }
        case Keys.Home:
        case Keys.End:
        case Keys.Up:
        case Keys.Down:
        case Keys.IEUp:
        case Keys.IEDown:
          {
            event.preventDefault(); // prevent scrolling
            this.accordionService.setFocus(this.itemIndex, event.key);
            break;
          }
      }
      this.headerKeyUp.emit(event);
    }
  }
  AccordionItemComponent.ɵfac = function AccordionItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionItemComponent)(i0.ɵɵdirectiveInject(AccordionService), i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  AccordionItemComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AccordionItemComponent,
    selectors: [["stb-accordion-item"]],
    viewQuery: function AccordionItemComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentRef = _t.first);
      }
    },
    inputs: {
      headerText: "headerText",
      icons: "icons",
      isActive: "isActive",
      itemIndex: "itemIndex",
      trackId: "trackId",
      headingLevel: "headingLevel",
      rebrand: "rebrand"
    },
    outputs: {
      headerClick: "headerClick",
      headerKeyUp: "headerKeyUp"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c4,
    decls: 5,
    vars: 15,
    consts: [["accordionContent", ""], ["role", "heading", 3, "headerClick", "headerKeyUp", "headerText", "icons", "isActive", "itemIndex", "uniqueId", "rebrand"], [1, "stb-accordion-content"]],
    template: function AccordionItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef(_c3);
        i0.ɵɵelementStart(0, "stb-accordion-header", 1);
        i0.ɵɵlistener("headerClick", function AccordionItemComponent_Template_stb_accordion_header_headerClick_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onHeaderPanelClick($event));
        })("headerKeyUp", function AccordionItemComponent_Template_stb_accordion_header_headerKeyUp_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onHeaderPanelKeyUp($event));
        });
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2, 0);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("active", ctx.isActive);
        i0.ɵɵproperty("headerText", ctx.headerText)("icons", ctx.icons)("isActive", ctx.isActive)("itemIndex", ctx.itemIndex)("uniqueId", ctx.uniqueId)("rebrand", ctx.rebrand);
        i0.ɵɵattribute("data-trackid", ctx.trackId)("aria-level", ctx.headingLevel);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("active", ctx.isActive);
        i0.ɵɵattribute("aria-hidden", ctx.isActive ? null : "true")("aria-labelledby", ctx.uniqueId + "-" + ctx.itemIndex)("id", ctx.uniqueId + "-c-" + ctx.itemIndex);
      }
    },
    dependencies: [AccordionHeaderComponent],
    encapsulation: 2
  });
  return AccordionItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionComponent = /*#__PURE__*/(() => {
  class AccordionComponent {
    constructor(accordionService) {
      this.accordionService = accordionService;
      this.toggleMultiple = false;
      this.headingLevel = 3;
      this.rebrand = false;
      /**
       * Font weight of the accordion header
       * @deprecated only works in legacy-mode
       */
      this.fontWeight = 700;
      this.componentClass = true;
      this.subscription$ = new Subscription();
    }
    get isRebrand() {
      return this.rebrand;
    }
    ngOnChanges(changes) {
      if (changes.rebrand) {
        this.accordionService.rebrand = this.rebrand;
      }
      if (changes.toggleMultiple) {
        this.resetAccordion();
      }
      if (changes.rebrand) {
        this.accordionService.rebrand = this.rebrand;
      }
      if (changes.fontWeight) {
        this.accordionService.fontWeight$.next(this.fontWeight);
      }
    }
    ngAfterContentInit() {
      this.resetAccordion();
      // listen for changes in accordionItems
      // so that consumer may change accordion-items dynamically
      this.subscription$.add(this.accordionItems.changes.subscribe(() => {
        if (this.accordionService.totalItems !== this.accordionItems.length) {
          this.resetAccordion();
        }
      }));
    }
    ngOnDestroy() {
      this.subscription$.unsubscribe();
    }
    resetAccordion() {
      setTimeout(() => {
        this.accordionService.accordionItems = this.accordionItems;
        this.accordionService.totalItems = this.accordionItems.length;
        this.accordionService.toggleMultiple = this.toggleMultiple;
        this.accordionService.setItemIndex();
      }, 0);
    }
  }
  AccordionComponent.ɵfac = function AccordionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionComponent)(i0.ɵɵdirectiveInject(AccordionService));
  };
  AccordionComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AccordionComponent,
    selectors: [["stb-accordion"]],
    contentQueries: function AccordionComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, AccordionItemComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordionItems = _t);
      }
    },
    hostVars: 4,
    hostBindings: function AccordionComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("stb-accordion-ng-root", ctx.componentClass)("rebrand", ctx.isRebrand);
      }
    },
    inputs: {
      toggleMultiple: "toggleMultiple",
      headingLevel: "headingLevel",
      rebrand: "rebrand",
      fontWeight: "fontWeight"
    },
    features: [i0.ɵɵProvidersFeature([AccordionService]), i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c1,
    decls: 2,
    vars: 2,
    consts: [[1, "stb-accordion"]],
    template: function AccordionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("rebrand", ctx.rebrand);
      }
    },
    styles: ["@font-face{font-family:System-Icons;src:url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.ttf) format(\"truetype\");text-rendering:optimizeLegibility}@font-face{font-family:Storebrand Symbols;src:url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.ttf) format(\"truetype\");text-rendering:optimizeLegibility}i.symbol{font-family:Storebrand Symbols!important}i{font-family:System-Icons!important;font-style:normal;font-weight:400!important;font-size:16px;line-height:16px;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}i:empty:not([class*=system-icon]){display:inline-flex;width:24px;height:24px;background:var(--color-primary)}.icon-xsmall{font-size:16px!important;line-height:16px!important}.icon-small{font-size:20px!important;line-height:20px!important}.icon-medium{font-size:24px!important;line-height:24px!important}.icon-large{font-size:32px!important;line-height:32px!important}@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}.stb-accordion-ng-root .rebrand{--p-accordion-border-radius: 8px;--p-accordion-animation: cubic-bezier(.175, .885, .32, 1) .1s}.stb-accordion-ng-root .rebrand stb-accordion-item{border-bottom:1px solid var(--p-color-stroke-subtle-0, #e9e2e2);padding:8px 0}.stb-accordion-ng-root .rebrand .clickable{cursor:pointer}.stb-accordion-ng-root .rebrand .stb-accordion-header{align-items:center;border-top-left-radius:var(--p-accordion-border-radius, 8px);border-top-right-radius:var(--p-accordion-border-radius, 8px);border:none;box-sizing:border-box;color:var(--p-color-text-primary, #2b2525);font-size:var(--p-font-styles-size-20, 1.25rem);line-height:var(--p-font-styles-line-height-desktop-20, 1.75);min-height:48px;padding:8px 16px;text-wrap:pretty}.stb-accordion-ng-root .rebrand .stb-accordion-header.active{background-color:var(--p-color-surface-1, #f7f3f3)}.stb-accordion-ng-root .rebrand .stb-accordion-header-right i.active{color:var(--p-color-icon-primary, #560000)}.stb-accordion-ng-root .rebrand .stb-accordion-header:hover{background-color:var(--p-color-background-hover);color:var(--p-color-text-primary)}.stb-accordion-ng-root .rebrand .stb-accordion-header:not(.active){border-bottom-left-radius:var(--p-accordion-border-radius, 8px);border-bottom-right-radius:var(--p-accordion-border-radius, 8px)}.stb-accordion-ng-root .rebrand .stb-accordion-header:focus-visible{outline:var(--p-outline);border-radius:var(--p-accordion-border-radius, 8px)}.stb-accordion-ng-root .rebrand .stb-accordion-header:active{background-color:var(--p-color-background-pressed, #e9e2e2)}.stb-accordion-ng-root .rebrand .stb-accordion-header span{font-family:Storebrand Text,sans-serif}.stb-accordion-ng-root .rebrand .stb-accordion-header i[class^=icon-]{margin-left:8px}.stb-accordion-ng-root .rebrand .stb-accordion-header-title{font-size:var(--p-font-styles-size-20, 1.25rem);font-weight:400;transition-property:font-weight;transition:var(--p-accordion-animation)}.stb-accordion-ng-root .rebrand .stb-accordion-header-title.active{font-weight:600}.stb-accordion-ng-root .rebrand .stb-accordion-content{background-color:var(--p-color-surface-1, #f7f3f3);border-bottom-left-radius:var(--p-accordion-border-radius, 8px);border-bottom-right-radius:var(--p-accordion-border-radius, 8px);border-bottom:none;color:var(--p-color-text-primary, #2b2525);font-family:Storebrand Text,sans-serif;font-size:var(--p-font-styles-size-18, 1.125rem);line-height:var(--p-font-styles-line-height-desktop-18, 1.625);text-wrap:pretty;display:block;opacity:0;height:0;overflow:hidden;padding:0 16px;transition-property:opacity,padding,height;transition:var(--p-accordion-animation)}.stb-accordion-ng-root .rebrand .stb-accordion-content.active{padding:0 16px 10px;opacity:1;height:-moz-fit-content;height:fit-content}.stb-accordion-ng-root .rebrand .stb-accordion-content ul,.stb-accordion-ng-root .rebrand .stb-accordion-content ol{padding:inherit}.stb-accordion-ng-root .rebrand .stb-accordion-content p{padding-top:.5rem;text-wrap:pretty}@media (max-width: 600px){.stb-accordion-ng-root .rebrand .stb-accordion-header{min-height:40px;padding:5px 16px}.stb-accordion-ng-root .rebrand .stb-accordion-header .stb-accordion-header-title{font-size:var(--p-font-styles-size-18, 1.125rem);line-height:var(--p-font-styles-line-height-mobile-18, 1.625)}.stb-accordion-ng-root .rebrand .stb-accordion-header i[class^=icon-]{font-size:20px!important;height:20px;line-height:20px!important;margin-left:8px;width:20px}.stb-accordion-ng-root .rebrand .stb-accordion-content{font-size:var(--p-font-styles-size-16, 1rem);line-height:var(--p-font-styles-line-height-mobile-16, 1.375)}}@media (prefers-reduced-motion: reduce){.stb-accordion-ng-root .rebrand .stb-accordion-header-title,.stb-accordion-ng-root .rebrand .stb-accordion-content{transition:none}}.stb-accordion-ng-root stb-accordion-header{display:grid}.stb-accordion-ng-root stb-accordion-item{display:block}.stb-accordion-ng-root:not(.rebrand) *{font-family:Open Sans,sans-serif}.stb-accordion-ng-root:not(.rebrand) * .stb-accordion-content em,.stb-accordion-ng-root:not(.rebrand) * .stb-accordion-header em{font-style:italic}.stb-accordion-ng-root:not(.rebrand) a{color:#bf0900;text-decoration:underline}.stb-accordion-ng-root:not(.rebrand) a.disabled,.stb-accordion-ng-root:not(.rebrand) a.disabled:hover,.stb-accordion-ng-root:not(.rebrand) a[disabled],.stb-accordion-ng-root:not(.rebrand) a[disabled]:hover{color:#757575;cursor:default;pointer-events:none}.stb-accordion-ng-root:not(.rebrand) a:visited{color:#757575}.stb-accordion-ng-root:not(.rebrand) a:hover{color:#aa0600}.stb-accordion-ng-root:not(.rebrand) a:focus{outline:2px solid #00f;outline-offset:4px}.stb-accordion-ng-root:not(.rebrand) a:focus:not(:focus-visible){outline:0}.stb-accordion-ng-root:not(.rebrand) a:focus-visible{outline:2px solid #00f;outline-offset:4px}.stb-accordion-ng-root:not(.rebrand) a[disabled]:focus-visible,.stb-accordion-ng-root:not(.rebrand) a.disabled:focus-visible{outline:2px solid #757575}.stb-accordion-ng-root .clickable{cursor:pointer}.stb-accordion-ng-root .stb-accordion{box-sizing:content-box;background-color:transparent;font-family:Open Sans,sans-serif;font-weight:400;transition:.4s}.stb-accordion-ng-root .stb-accordion-header{all:unset;border-bottom:1px solid rgba(25,25,25,.16);color:#191919;display:flex;font-size:16px;line-height:24px;min-height:55px;position:relative;align-items:center;transition:background-color .1s ease-out}.stb-accordion-ng-root .stb-accordion-header:hover{color:#bf0900;background-color:#1919190d}.stb-accordion-ng-root .stb-accordion-header.active{border-bottom:1px solid transparent}.stb-accordion-ng-root .stb-accordion-header.active svg{color:#bf0900}.stb-accordion-ng-root .stb-accordion-header:active{background-color:#0000001a}.stb-accordion-ng-root .stb-accordion-header-left{flex-grow:1}.stb-accordion-ng-root .stb-accordion-header-right i.active{color:#bf0900}.stb-accordion-ng-root .stb-accordion-header-title{font-family:Open Sans,sans-serif;font-weight:700;font-size:16px;margin:0;padding:0}.stb-accordion-ng-root .stb-accordion-header:focus{outline:2px solid #00f;outline-offset:4px}.stb-accordion-ng-root .stb-accordion-header:focus:not(:focus-visible){outline:0}.stb-accordion-ng-root .stb-accordion-header:focus-visible{outline:2px solid #00f;outline-offset:4px}.stb-accordion-ng-root .stb-accordion-content{border-bottom:1px solid rgba(25,25,25,.16);font-size:16px;line-height:150%;display:none;padding:16px 0 32px}.stb-accordion-ng-root .stb-accordion-content.active{display:block}\n"],
    encapsulation: 2
  });
  return AccordionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccordionModule = /*#__PURE__*/(() => {
  class AccordionModule {}
  AccordionModule.ɵfac = function AccordionModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionModule)();
  };
  AccordionModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: AccordionModule
  });
  AccordionModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
  return AccordionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of accordion
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AccordionHeaderComponent, AccordionItemComponent, AccordionModule, AccordionService };
